import {
  HHError,
  HHStack,
  HHTextField,
} from '@hinge-health/react-component-library';
import { Autocomplete } from '@mui/material';
import { useGetAllClientsQuery } from '../../types';
import LoadingComponent from '../utils/loading';

export interface ProgramCapFilterProps {
  filterCallback: (clientId: number | null) => void;
}

export const ProgramCapFilter = ({
  filterCallback,
}: ProgramCapFilterProps): JSX.Element => {
  const { data, loading, error } = useGetAllClientsQuery();

  const clients = (data?.getAllClients ?? [])
    .filter(client => client && client.name)
    .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))
    .map(client => ({
      name: client.name,
      id: client.id,
    }));

  if (loading) return <LoadingComponent center />;

  if (error)
    return <HHError body="Error fetching clients" hhVariant="variant-bypass" />;

  return (
    <HHStack>
      <Autocomplete
        options={clients}
        getOptionLabel={(option): string => option.name}
        onChange={(_, newValue): void => {
          filterCallback(newValue?.id ?? null);
        }}
        size="small"
        sx={{ minWidth: 230 }}
        renderInput={(params): JSX.Element => (
          <HHTextField
            {...params}
            hhVariant="variant-bypass"
            variant="standard"
            label="Client"
          />
        )}
      />
    </HHStack>
  );
};
